import { Calendar } from "lucide-react";

function LegendItem({
  color,
  label,
  value,
}: {
  color: string;
  label: string;
  value: string;
}) {
  return (
    <div className="flex items-center justify-between text-xs">
      <div className="flex items-center gap-2">
        <div
          className="h-2.5 w-2.5 rounded-full"
          style={{ backgroundColor: color }}
        />
        <span className="text-muted-foreground">{label}</span>
      </div>
      <span className="font-medium text-secondary">{value}</span>
    </div>
  );
}

const PaymentManagementEventsChart = () => {
  return (
    <div className="rounded-2xl border border-border/60 bg-card text-card-foreground shadow-sm transition-shadow duration-300 hover:shadow-md">
      {/* Header */}
      <div className="flex flex-col space-y-1.5 p-6 pb-2">
        <h3 className="flex items-center gap-2 text-base font-bold tracking-tight text-foreground">
          <Calendar className="h-4 w-4 text-primary" />
          By Frequency
        </h3>
      </div>

      {/* Pie chart + Legend */}
      <div className="p-6 pt-0">
        <div className="flex items-center gap-4">
          {/* Pie Chart */}
          <div className="h-28 w-28">
            {/* Insert Pie Chart here */}
            {/* <YourPieChart /> */}
          </div>

          {/* Legend */}
          <div className="flex-1 space-y-2">
            <LegendItem color="#3B82F6" label="Monthly SIP" value="₹420K" />
            <LegendItem color="#22C55E" label="Quarterly" value="₹180K" />
            <LegendItem color="#F59E0B" label="One-time" value="₹95K" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentManagementEventsChart;
